
<template>
  <div style="padding: 20px;">
    <div style="line-height: 35px;font-size: 14px;">应选课时：{{productInfo.ksyq}} <span style="padding-left: 30px;"></span>已选课时：{{yxks}}</div>
    <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column label="名称" width="120">
        <template slot-scope="scope">{{ scope.row.cname }}</template>
      </el-table-column>
      <el-table-column prop="author" label="讲师" width="120">
      </el-table-column>
      <el-table-column prop="ks" label="课时" width="120">
      </el-table-column>
      <el-table-column prop="xstime" label="时长" show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <el-pagination background style="margin-top: 10px;text-align: right;" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :current-page="formInline.page" :page-sizes="[10, 20, 50, 100]"
      :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total">
    </el-pagination>
  </div>
</template>

<script>
  import {
    getTimer,
    format
  } from '../../assets/js/common.js'
  export default {
    name: 'Muhistor',
    props: ['wjSrc'],
    data() {
      return {
        tableData: [],
        loading: true,
        formInline: {
          currId: 'pgdvrrkw7xjw51269n1iwr9j6834fpnz',
          page: 1,
          rows: 10
        },
        productInfo: {
          ksyq: 0
        },
        yxks: 0
      }
    },
    methods: {
      getList: function(id) {
        this.loading = true;
        this.$axios.get('/kt/wz/productInfo/getKcByCurrId.htm?' + this.$qs.stringify(this.formInline)).then(res => {
          var data = res.data;
          this.tableData = data.rows;
          this.loading = false;
        })
      },
      handleSelectionChange: function(row, rows) {
        var yxks=0;
        row.map((item,i)=>{
          yxks+=Number(item.ks);
        });
        this.yxks=yxks; 
        

      },
      changeParams: function(key, val) {
        this.$set(this.formInline, key, val);
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      // 获取产品详情
      getDetail: function(id) {
        this.$axios.get('/kt/wz/productInfo/getProdcutallDetail.htm?id=' + id, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.productInfo = data.data;
          }
        })
      }
    },
    components: {},
    created: function() {
      this.getList();
      this.getDetail('pgdvrrkw7xjw51269n1iwr9j6834fpnz');
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/xueyuan/Selectkcxs.vue